<template>
  <v-card class="searchpanel" flat color="transparent">
    <v-card-title class="pb-0 mb-0 justify-center">
      <h2>Finde deine nächste Saisonstelle</h2>
    </v-card-title>
    <v-card-text>
      <v-container @keyup.enter="toJobList" class="pa-0">
        <v-row>
          <v-col :cols="12">
            <v-text-field
              append-icon="search"
              :placeholder="$t('texts.insertJobtitle')"
              hide-details
              v-model="searchTerm"
              solo
              @click:append="toJobList"
              rounded
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');

export default {
  name: 'Searchpanel',
  data() {
    return {
      searchTerm: null,
    };
  },
  computed: {
    ...mapUserState([
      'predefinedSeason',
    ]),
  },
  methods: {
    ...mapUserActions([
      'setPredefinedSeason',
    ]),
    toJobList() {
      this.$router.push({
        name: 'job.list',
        params: {
          lang: this.$i18n.locale,
        },
        query: {
          query: this.searchTerm,
        },
      });
    },
  },
};
</script>
